import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";

/**
 * Unified routing — all sections and legal/help documents are resolved
 * through a single ?section= query parameter on the home view, so there are
 * no separate folder sub-routes anymore.
 */
const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;